// Utils
import { IonText } from '@ionic/react';

// Styles
import styles from '@/components/BulletList/BulletList.module.css';

// Types

interface BulletListProps {
  listItems: string[];
}

export const BulletList = ({ listItems }: BulletListProps) => (
  <ul className={styles.bulletList}>
    {listItems.map((item, index) => (
      <li key={index}>
        <IonText className={styles.bulletListItem}>{item}</IonText>
      </li>
    ))}
  </ul>
);
